export default "__VITE_ASSET__Ee4Iizd8__"